import React from 'react';
import { Alert } from '@edgebox/react-components';

export function LoadingCard({ text }: { text: string }) {
  return (
    <Alert variant="light" className="mb-3">
      {text}
    </Alert>
  );
}
